/* AURA Studio RC1.1.3 — Smart Logo Engine */
(() => {
  const cfg = window.AuraSmartLogo || {};
  const body = document.body;
  if (!body) return;

  const findLogoLink = () => {
    return document.querySelector(
      '.shopify-section-group-header-group .header__heading-link, .aura-nav3__logo, .aura-nav4__logo'
    );
  };

  const findLogoImg = (link) => {
    return link?.querySelector('img') || document.querySelector('.shopify-section-group-header-group .header__heading-logo');
  };

  const css = (name, value) => {
    if (value !== undefined && value !== null && value !== '') {
      document.documentElement.style.setProperty(name, value);
    }
  };

  css('--aura-logo-height-desktop', (cfg.heightDesktop || 42) + 'px');
  css('--aura-logo-height-mobile', (cfg.heightMobile || 32) + 'px');
  css('--aura-logo-scroll-scale', cfg.scrollScale || .88);

  if (cfg.invertSingleLogo) body.classList.add('aura-smart-logo-invert');

  const apply = () => {
    const link = findLogoLink();
    if (!link || link.dataset.auraSmartLogoReady === 'true') return;

    const current = findLogoImg(link);
    const hasLight = !!cfg.logoLight;
    const hasDark = !!cfg.logoDark;

    link.style.background = 'transparent';
    link.dataset.auraSmartLogoReady = 'true';

    if (hasLight && hasDark) {
      const wrap = document.createElement('span');
      wrap.className = 'aura-smart-logo-wrap';
      wrap.setAttribute('data-aura-smart-logo', '');

      const dark = document.createElement('img');
      dark.className = 'aura-smart-logo--dark';
      dark.src = cfg.logoDark;
      dark.alt = cfg.alt || 'Logo';
      dark.setAttribute('data-aura-smart-logo-img', 'dark');

      const light = document.createElement('img');
      light.className = 'aura-smart-logo--light';
      light.src = cfg.logoLight;
      light.alt = cfg.alt || 'Logo';
      light.setAttribute('data-aura-smart-logo-img', 'light');

      wrap.appendChild(dark);
      wrap.appendChild(light);

      if (current) current.replaceWith(wrap);
      else link.appendChild(wrap);
    } else if (current) {
      current.setAttribute('data-aura-smart-logo-img', 'single');
      current.style.background = 'transparent';
    }
  };

  apply();

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-aura-smart-logo-ready]').forEach(el => delete el.dataset.auraSmartLogoReady);
    setTimeout(apply, 80);
  });

  // Detecta fondos del hero de forma simple: en home mantiene logo claro hasta scroll.
  const update = () => {
    const transparent = body.classList.contains('aura-rc-transparent-header') && !body.classList.contains('aura-rc-scrolled');
    body.classList.toggle('aura-smart-logo-on-hero', transparent);
  };

  update();
  window.addEventListener('scroll', update, { passive: true });
})();
